import { useTranslation } from "react-i18next";
import React from "react";

const ViewProblemTableRegulation = ({ problemList, field, moduleText }) => {

  const { t } = useTranslation();

  return (
    <div>
      <div className="table-responsive-xxl">
        <table className="table">
        <caption className="form-label tit-view-view tit-content-view-view" style={{captionSide:"top"}}> {t(`${moduleText}.synthetic.${field}`)}</caption>
          <thead className="table-light">
            <tr>
              <th>Id</th>
               <th>{t("regulation.table_problems.description")}</th>
            </tr>
          </thead>
          <tbody>
            {problemList && problemList.length > 0 ? (
              problemList.map((rw, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{rw && rw.CatProblem_To_ModProblem && rw.CatProblem_To_ModProblem.description}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="10"
                  style={{
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  No existen registros
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewProblemTableRegulation;
